export const PAY_DATES: string[] = ["Monthly on day 28th", "Fourth Friday of the month", "Last Friday of the month"];
